import { useEffect, useState } from "react";
import { gameApi } from "@/lib/api";
import { toast } from "sonner";

const FIELDS = [
  ["show_minutes", "Show length (minutes)"],
  ["champ_hours", "Championship length (hours)"],
  ["champ_frequency_hours", "Championship frequency (hours)"],
  ["show_entry_cost", "Show entry cost (coins)"],
  ["champ_entry_cost", "Championship entry cost (coins)"],
  ["show_base_coin", "Show coin per place"],
  ["champ_base_coin", "Championship coin per place"],
  ["point_per_place", "Points per place"],
  ["win_bonus", "Win bonus points"],
];

export const ShowsAdmin = () => {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { gameApi.get("/game/admin/shows/config").then((r) => setCfg(r.data.config)).catch(() => setCfg({})); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await gameApi.post("/game/admin/shows/config", cfg); setCfg(data.config); toast.success("Show settings saved"); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); } finally { setBusy(false); }
  };
  if (!cfg) return <p className="mt-4 text-center text-sm text-muted-foreground">Loading…</p>;
  return (
    <div className="mt-3 space-y-2" data-testid="admin-shows">
      <p className="text-xs text-muted-foreground">Applies to all disciplines. The scheduler settles ended shows and opens the next automatically.</p>
      {FIELDS.map(([k, l]) => (
        <div key={k} className="flex items-center justify-between gap-2 rounded-xl border border-border bg-card p-2.5">
          <label className="text-sm font-semibold text-primary">{l}</label>
          <input data-testid={`shows-cfg-${k}`} type="number" min="1" step="1" value={cfg[k] ?? ""} onChange={(e) => setCfg({ ...cfg, [k]: e.target.value })}
            className="w-24 rounded-lg border border-border bg-background px-2 py-1.5 text-sm" />
        </div>
      ))}
      <button data-testid="shows-cfg-save" disabled={busy} onClick={save} className="mt-1 h-11 w-full rounded-xl bg-primary font-bold text-primary-foreground">{busy ? "Saving…" : "Save Show Settings"}</button>
    </div>
  );
};
